import { _treatments } from "../constants/api";

export const fetchTreatmentPlan = async () => {
  try {
    const userData = JSON.parse(localStorage.getItem('user'));
    const token = userData?.token;

    if (!token) {
      throw new Error('Token not found');
    }

    const response = await fetch(`${_treatments}`, {
      method: "GET",
      headers: {
        'Authorization': `Bearer ${token}`,
        'clientid': 'e0ce9cb8-430e-4148-b562-b8833cc9fa0b',
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch treatments: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.log('Error in fetchtreatmentss API ==> ', error);
    throw error;
  }
};

export const createTreatmentPlan = async (image) => {
  try {
    const userData = JSON.parse(localStorage.getItem('user'));
    const token = userData?.token;

    if (!token) {
      throw new Error('Token not found');
    }

    

    const response = await fetch(`${_treatments}/create`, {
      method: "POST",
      headers: {
        'Authorization': `Bearer ${token}`,
        'clientid': 'e0ce9cb8-430e-4148-b562-b8833cc9fa0b',
      },
      body: image,
    });

    if (!response.ok) {
      throw new Error(`Failed to create treatments: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.log('Error in create treatments API ==> ', error);
    throw error;
  }
};

export const deleteTreatmentPlan = async (id) => {
  try {
    const userData = JSON.parse(localStorage.getItem('user')); 
    const token = userData?.token;

    if (!token) {
      throw new Error('Token not found');
    }

    const response = await fetch(`${_treatments}/${id}`, {
      method: "DELETE",
      headers: {
        'Authorization': `Bearer ${token}`,
        'clientid': 'e0ce9cb8-430e-4148-b562-b8833cc9fa0b',
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to delete treatments: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.log('Error in delete treatments API ==> ', error);
    throw error;
  }
};
